import { Link, useRouterState } from "@tanstack/react-router";
import { locales, localeLabel } from "@/i18n/config";
import { shared } from "@/i18n/shared";
import { useLocale } from "@/i18n/LocaleProvider";
import { alternatesForPath } from "@/i18n/alternates";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const active = useLocale();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const alternates = alternatesForPath(pathname);

  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      role="group"
      aria-label={shared[active].languageSwitcherAria}
    >
      {locales.map((loc) => (
        <Link
          key={loc}
          to={alternates[loc]}
          lang={loc}
          aria-current={loc === active ? "true" : undefined}
          className={
            loc === active
              ? "px-2 py-1 text-xs font-semibold text-foreground"
              : "px-2 py-1 text-xs font-medium text-foreground/60 hover:text-foreground transition-colors"
          }
        >
          {localeLabel[loc]}
        </Link>
      ))}
    </div>
  );
}
